import React, { useState } from 'react'
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Box,
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Image,
  Flex,
} from '@chakra-ui/react'
import { format } from 'date-fns'

export function Tabela({ data, setPriorityColor }) {
  const [selectedItem, setSelectedItem] = useState(null)
  const { isOpen, onOpen, onClose } = useDisclosure()

  const handleRowClick = (item) => {
    setSelectedItem(item)
    onOpen()
  }

  // Formatar a data se existir
  const formatDate = (dateString) => {
    if (!dateString) return 'Data não disponível'
    return format(new Date(dateString), 'dd/MM/yyyy HH:mm')
  }

  return (
    <>
      <Box overflowX="auto">
        <Table variant="simple" size="sm">
          <Thead bg="gray.100">
            <Tr>
              <Th>Nº</Th>
              <Th>Tipo</Th>
              <Th>Prioridade</Th>
              <Th>Data</Th>
              <Th>Status</Th>
              <Th>Solicitante</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.length > 0 ? (
              data.map((item) => (
                <Tr key={item.numero_chamado} onClick={() => handleRowClick(item)} _hover={{ bg: 'gray.50', cursor: 'pointer' }}>
                  <Td fontWeight="semibold">#{item.numero_chamado}</Td>
                  <Td>{item.tipo_chamado}</Td>
                  <Td>
                    <Badge colorScheme={setPriorityColor(item.prioridade).split('.')[0]}>{item.prioridade}</Badge>
                  </Td>
                  <Td>{formatDate(item.data_abertura)}</Td>
                  <Td>
                    <Badge colorScheme={item.resolucao_problema ? 'green' : 'yellow'}>{item.resolucao_problema ? 'Concluído' : 'Em aberto'}</Badge>
                  </Td>
                  <Td>{item.solicitante}</Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={6} textAlign="center" py={4}>
                  Nenhum chamado encontrado
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Box>

      {/* Modal com detalhes */}
      {selectedItem && (
        <Modal isOpen={isOpen} onClose={onClose} size="xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              <Flex alignItems="center">
                <Text>Chamado #{selectedItem.numero_chamado}</Text>
                <Badge ml={2} colorScheme={selectedItem.resolucao_problema ? 'green' : 'yellow'}>
                  {selectedItem.resolucao_problema ? 'Concluído' : 'Em aberto'}
                </Badge>
              </Flex>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box mb={4}>
                <Text fontWeight="bold">Tipo:</Text>
                <Text>{selectedItem.tipo_chamado}</Text>
              </Box>

              <Box mb={4}>
                <Text fontWeight="bold">Data de Abertura:</Text>
                <Text>{formatDate(selectedItem.data_abertura)}</Text>
              </Box>

              <Box mb={4}>
                <Text fontWeight="bold">Prioridade:</Text>
                <Badge colorScheme={setPriorityColor(selectedItem.prioridade).split('.')[0]}>{selectedItem.prioridade}</Badge>
              </Box>

              <Box mb={4}>
                <Text fontWeight="bold">Solicitante:</Text>
                <Text>{selectedItem.solicitante}</Text>
              </Box>

              <Box mb={4}>
                <Text fontWeight="bold">Detalhes do Problema:</Text>
                <Text whiteSpace="pre-wrap">{selectedItem.detalhes_problema}</Text>
              </Box>

              {selectedItem.resolucao_problema && (
                <Box mb={4}>
                  <Text fontWeight="bold">Resolução:</Text>
                  <Text whiteSpace="pre-wrap">{selectedItem.resolucao_problema}</Text>
                </Box>
              )}

              {selectedItem.link_imagem && (
                <Box mb={4}>
                  <Text fontWeight="bold" mb={2}>
                    Imagem:
                  </Text>
                  <Image
                    src={selectedItem.link_imagem}
                    alt="Imagem do chamado"
                    maxH="300px"
                    objectFit="contain"
                    borderRadius="md"
                    fallbackSrc="https://via.placeholder.com/400x300?text=Imagem+não+disponível"
                  />
                </Box>
              )}
            </ModalBody>

            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={onClose}>
                Fechar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  )
}
